import Vue from 'vue';
import VueRouter from 'vue-router';
import { BootstrapVue } from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAt } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import App from './App.vue';
import CookiePrivacyPage from './page-components/CookiePrivacyPage.vue';
import HomePage from './page-components/HomePage.vue';
import NotFound from './page-components/NotFoundPage.vue';
import ResumePage from './page-components/ResumePage';
import PhotographyPage from './page-components/PhotographyPage';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';

Vue.config.productionTip = false;
Vue.prototype.window = window;
Vue.use(BootstrapVue);
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: App,
      children: [
        { path: '/', component: HomePage },
        { path: '/resume', component: ResumePage },
        { path: '/photography', component: PhotographyPage },
        { path: '/cookieandprivacy', component: CookiePrivacyPage },
        { path: '/notfound', component: NotFound },
        { path: '*', redirect: '/notfound'}
      ]
    }
  ]
});

library.add(
  faAt,
  faGithub,
  faLinkedinIn
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({ router }).$mount('#app');
